import { DKGrid } from "../DKGrid";
import { DKGridTitleBar, DKGridTitleBarProps } from "./DKGridTitleBar";
import { Grid, GridProps } from "@mui/material";
import React from "react";
import { DKGridColumnProps } from "./DKGridColumn";
import Delimiter from "../forms/delimiter/Delimiter";
import { uid } from "../../../helpers/utilsTS";

export type DKGridTableProps = DKGridTitleBarProps & {
  rowsLength: number;
  children: React.ReactElement<DKGridColumnProps>[];
  footer?: React.ReactElement<GridProps> | React.ReactElement<GridProps>[];
};

export const DKGridTable = (props: DKGridTableProps) => {
  const { title, actionButtons, rowsLength, children, footer } = props;
  const footerArray = footer && Array.isArray(footer) ? footer : [footer];

  return (
    <DKGrid container marginTop={"20px"}>
      <DKGridTitleBar title={title} actionButtons={actionButtons} />
      <Grid container spacing={2}>
        {rowsLength > 0 && (
          <>
            {children.map((column) => {
              return column;
            })}
          </>
        )}
      </Grid>
      {footer && footerArray && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Delimiter type="internal" shift="20" />
            </Grid>
          </Grid>
          {footerArray.map((footerGrid) => {
            return { ...footerGrid, key: uid.randomUUID() };
          })}
        </>
      )}
    </DKGrid>
  );
};
